import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import EmailProviderRow from "~/components/settings/EmailProviderRow";
import OutlookMailboxConnectCard from "~/components/settings/OutlookMailboxConnectCard";

const LinkedEmailAccountSection = () => {
	const { t } = useTranslation("common");

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
			<OutlookMailboxConnectCard />
			<EmailProviderRow
				action={<Chip label={t("preferences.linkedEmail.comingSoon")} size="small" variant="outlined" />}
				icon="mail"
				statusText={t("preferences.linkedEmail.googleStatus")}
				title={t("preferences.linkedEmail.googleTitle")}
			/>
		</Box>
	);
};

export default LinkedEmailAccountSection;
